import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import WarningIcon from "@mui/icons-material/Warning";
import { useEffect } from "react";
import { LoadingButton } from "@mui/lab";
import PostHooks from "../../../../Api/PostHooks";
import AlertComponent from "../../../../Components/AlertComponent";

const DeleteKinForm = ({ user, data, onClose, onSuccess }) => {
  const { handleSubmit } = useForm();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const [loading, response, request] = PostHooks();

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const deleteKin = async () => {
    try {
      let formData = {
        next_kin_id: user?.next_kin_id,
      };

      const delReq = await request({
        url: "delete_kin",
        body: formData,
      });

      if (delReq && delReq.status === 200 && delReq.data.StatusCode === 0) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Next Kin deletion successful!",
        });
        setTimeout(() => {
          onClose();
          onSuccess();
        }, 1000);
      } else {
        const errorMessage =
          delReq?.data?.StatusMessage ??
          delReq?.data?.message ??
          delReq.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(deleteKin)}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <Stack>
        <IconButton aria-label="caution" color={"warning"}>
          <WarningIcon sx={{ fontSize: 150 }} />
        </IconButton>

        <Typography align="center">
          You are about to delete your next of kin!
        </Typography>
      </Stack>

      <Box
        sx={{
          display: "flex",
          gap: 2,
          justifyContent: "flex-end",
          mt: 5,
          mx: 3,
        }}
      >
        <Button
          variant="outlined"
          color="primary"
          type="reset"
          onClick={onClose}
        >
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          color="primary"
          type="submit"
          loading={loading}
        >
          Confirm
        </LoadingButton>
      </Box>
    </form>
  );
};

export default DeleteKinForm;
